module.exports = __webpack_public_path__ + "static/img/z2.64af44e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/z2.png
// module id = 2bd0
// module chunks = 0